import { useEffect } from 'react';

export function useLightboxVideoEffect(isNative: boolean, posterUrl?: string) {
  useEffect(() => {
    let cleanup: (() => void) | undefined;

    const svgElement = document.querySelector('[class*="VideoPoster_module_loadButton"] svg');
    const videoElement = document.querySelector(
      '[class*="NativeVideoPlayer_module_video"]',
    ) as HTMLVideoElement;

    if (isNative && posterUrl && svgElement) svgElement.setAttribute('tabindex', '0');

    if (isNative && !posterUrl && videoElement) {
      videoElement.setAttribute('role', 'button');
      videoElement.setAttribute('tabindex', '0');

      const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
          videoElement.play();

          setTimeout(() => {
            const playButton = document.querySelector('[class*="InlineControls_module_playButton"]');
            if (playButton) {
              playButton.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
          }, 100);
        }
      };

      videoElement.addEventListener('keydown', handleKeyDown);

      // Assign the cleanup function to the variable
      cleanup = () => videoElement.removeEventListener('keydown', handleKeyDown);
    }

    // Appeasing the linter - returns either the cleanup function or undefined
    return cleanup;
  }, [isNative, posterUrl]);
}
